import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import useCancelToken from '../../../../../_gori/hooks/UseCancelToken'
import {useCallback, useState} from 'react'
import A1BatchService from '../../core/_requests'
import {ConfirmActionModal} from '../../../../../_gori/components'
import clsx from 'clsx'

type RemoveA1BatchProps = {
  id: string
  onSuccess?: () => void
  onError?: (error: any) => void
  className?: string
  disabled?: boolean
}
export const RemoveA1Batch = ({
  id,
  onSuccess,
  onError,
  className,
  disabled,
}: RemoveA1BatchProps) => {
  const intl = useIntl()
  const {newCancelToken, isCancel} = useCancelToken()

  const [dataConfirmation, setDataConfirmation] = useState<{
    title?: string | null
    message?: any
    callback: any
  }>({title: null, message: null, callback: null})
  const [showConfirmation, setShowConfirmation] = useState(false)

  const handleRemoveA1Batch = async ({hasPass = false}) => {
    if (disabled) return

    if (!hasPass) {
      setDataConfirmation({
        title: intl.formatMessage({id: 'REMOVE_A1_BATCH'}),
        message: (
          <span className='text-center'>
            <p>{intl.formatMessage({id: 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_A1_BATCH'})}</p>
            <p>
              {intl.formatMessage({
                id: 'REMOVING_A1_BATCH_DOES_NOT_DELETE_THE_ORDERS_UPLOADED_INSIDE_A1_BATCH',
              })}
            </p>
          </span>
        ),
        callback: () => handleRemoveA1Batch({hasPass: true}),
      })
      return setShowConfirmation(true)
    }

    try {
      const res = await A1BatchService.removeBatch(id, {cancelToken: newCancelToken()})
      if (res) {
        toast.success(intl.formatMessage({id: 'DELETED_A1_BATCH_SUCCESSFULLY'}))
        onSuccess?.()
      }
    } catch (error: any) {
      if (isCancel(error)) return
      onError?.(error?.response)
    }
  }

  const handleConfirmAction = useCallback(async () => {
    setShowConfirmation(false)
    await dataConfirmation.callback()
    await setDataConfirmation({
      callback: null,
    })
  }, [dataConfirmation])

  const handleCloseConfirmAction = useCallback(() => {
    setDataConfirmation({
      title: null,
      message: null,
      callback: null,
    })
    setShowConfirmation(false)
  }, [setShowConfirmation])

  return (
    <>
      <div
        className={clsx(className, {'cursor-no-drop opacity-50': disabled})}
        onClick={() => handleRemoveA1Batch({hasPass: false})}
      >
        {intl.formatMessage({id: 'REMOVE_A1_BATCH'})}
      </div>
      {showConfirmation && (
        <ConfirmActionModal
          show={showConfirmation}
          classNameDialog='modal-size-lg'
          title={dataConfirmation?.title}
          message={
            dataConfirmation?.message || (
              <span className='fw-bold text-center'>
                <p>{intl.formatMessage({id: 'ARE_YOU_SURE_YOU_WANT_TO_PROCEED'})}</p>
                <p>
                  {intl.formatMessage({
                    id: 'THIS_ACTION_CANNOT_BE_UNDONE_PLEASE_REVIEW_YOUR_DECISION_CAREFULLY_BEFORE_PROCEEDING',
                  })}
                </p>
              </span>
            )
          }
          messagePrimary={intl.formatMessage({id: 'CONFIRM'})}
          messageSecondary={intl.formatMessage({id: 'CANCEL'})}
          handlePrimaryAction={handleConfirmAction}
          handleSecondaryAction={handleCloseConfirmAction}
          handleClose={handleCloseConfirmAction}
        />
      )}
    </>
  )
}
